import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import UserRating from './UserRating';

loadDOMComponent({
	selector: 'react-user-rating',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const caseId = container.getAttribute('caseId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<UserRating caseId={caseId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
